export const getCAFPrequalUrl = (vinData, isProdEnv, ted6504Recipe, isForceDefault) => {
  const isTED6504Chal1 = ted6504Recipe === 'chal-1';
  const ted6504Suffix = ['chal-1', 'chal-2'].includes(ted6504Recipe) ? '_chal' : '_ctrl';
  const adCodeSuffix = isForceDefault ? '' : ted6504Suffix;

  return `https://${isProdEnv ? 'www' : 'wwwqa'}.carmax.com/pre-qual/edmunds${
    isTED6504Chal1 ? `/${vinData?.stockNumber ?? ''}` : ''
  }?adcode=EDM${adCodeSuffix}&utm_campaign=LG_AFF&utm_source=LG_AFF_Edmunds&utm_medium=referral&utm_content=get_pq_${
    isTED6504Chal1 ? '' : 'n'
  }vsp`;
};
